import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Center,
  Card,
  CardBody,
  Button,
  Text,
  Heading,
  Image,
  Stack,
  CardFooter,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate, Link } from "react-router-dom";

export default function CampaignCard(props) {
  const navigate = useNavigate();
  const owner = props.owner || false;
  const campaign = props.campaign;

  return (
    <Card m="5">
      <CardBody m="xs">
        {campaign.cover && (
          <Image
            opacity={campaign.disabled ? ".55" : "1"}
            src={"https://hubitprototype.herokuapp.com" + campaign.cover}
            fallbackSrc="https://via.placeholder.com/350x200"
            boxSize="200px"
            alt={`${campaign.brand} campaign cover image`}
            borderRadius="lg"
            width="100%"
            objectFit="cover"
          />
        )}
        <Stack opacity={campaign.disabled ? ".55" : "1"} mt="6" spacing="3">
          <Heading size="md">{campaign?.name}</Heading>
          <Box>
            {campaign.description && (
              <Text>
                <Heading color="gray.400" fontSize="xs">
                  DESCRIPTION:
                </Heading>
                {campaign.description}
              </Text>
            )}
          </Box>
          <Box>
            {campaign.genre && (
              <Text>
                <Heading color="gray.400" fontSize="xs">
                  GENRE:
                </Heading>
                {campaign.genre}
              </Text>
            )}
          </Box>
          <Box>
            {campaign.brand && (
              <Text>
                <Heading color="gray.400" fontSize="xs">
                  PRODUCTION COMPANY:
                </Heading>
                <Link to={`/brand/${campaign.brand}`}>{campaign.brand}</Link>
              </Text>
            )}
          </Box>
        </Stack>
      </CardBody>
      <CardFooter pt="0" justify="space-between" flexWrap="wrap">
        {owner ? (
          <Button
            onClick={(e) =>
              navigate(`/brandCampaigns/reports?campaign=${campaign?.name}`)
            }
            mx="auto"
            variant="solid"
            colorScheme="gray"
          >
            View Reports
          </Button>
        ) : !campaign.disabled ? (
          <Button
            isDisabled={campaign.disabled}
            mx="auto"
            py="0"
            height="35px"
            variant="solid"
            colorScheme="teal"
            onClick={() =>
              navigate(`/campaign/${campaign.brand}/${campaign.name}`)
            }
          >
            Evaluate
          </Button>
        ) : (
          <Box width="100%">
            <Center>
              <Text as="i" color="teal">
                Completed!
              </Text>
            </Center>
          </Box>
        )}
      </CardFooter>
    </Card>
  );
}
